module.exports = __webpack_public_path__ + "officialStatic/img/astronaut1.6ab55bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/astronaut1.png
// module id = YPK1
// module chunks = 0